app.factory("AgreementService", ["$http",
    function ($http) {
        var AgreementService = {};

        AgreementService.sendList = function (params) {
            return $http.get("/agreement", {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 25,
                    query: params.query,
                    fromDate: params.fromDate,
                    toDate: params.toDate,
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        AgreementService.send = function (agreement) {
            return $http.post("/agreement/add", agreement).then(function (resp) {
                return resp.data;
            });
        };

        AgreementService.unread = function () {
            return $http.get("/agreement/active").then(function (resp) {
                return resp.data;
            })
        };

        AgreementService.mark = function (params) {
            const body = {
                _id: params._id,
                status: params.status
            };

            return $http.put("/agreement/action", body).then(function (resp) {
                return resp.data;
            });
        };

        return AgreementService;
    }
]);
